import React, { useContext, useEffect, useState } from "react";
import { Typography } from "@rmwc/typography";
import { Button } from "@rmwc/button";
import { AppContext } from "../contexts/App";

import { Overlay } from "react-portal-overlay";
import {
  DisclaimerMessage,
  ApplicationName,
  Version,
  ShowDisclaimerOnPageLoad,
} from "../appConfig";
import useLocalStorage from "react-use/lib/useLocalStorage";

const SplashScreen = () => {
  const { state, setState } = useContext(AppContext);
  const KEY = "mugis-template-disclaimer-seen";
  const [cache, setCache] = useLocalStorage(KEY);
  //const [open, setOpen] = React.useState(false);
  const [open, setOpen] = ShowDisclaimerOnPageLoad
    ? cache
      ? Math.round(Date.now() / 1000) - parseInt(cache.toString()) < 86400
        ? useState(false)
        : useState(true)
      : useState(true)
    : useState(false);
  //setCache = () => {}

  useEffect(() => {
    setOpen(open);
    return () => {
      /* if (cleanup) {
          cleanup();
        } */
    };
  }, []);

  useEffect(() => {
    if (state.showDisclaimer !== null) {
      setOpen(state.showDisclaimer);
    }
    return () => {
      /* if (cleanup) {
          cleanup();
        } */
    };
  }, [state.showDisclaimer]);

  return (
    <>
      <Overlay
        id="splashScreen"
        open={open}
        closeOnClick={false}
        onClose={() => {
          setOpen(false);
          setState({
            showDisclaimer: false,
          });
        }}
      >
        <div id="splashScreenHeader">
          <div
            className="toolbar__leading-icon"
            style={{ marginRight: "10px" }}
          ></div>
          <Typography use="headline6">{ApplicationName}</Typography>
        </div>
        <div id="splashScreenDisclaimer">
          <Typography use="headline6">DISCLAIMER</Typography>
        </div>
        <Typography
          use="body2"
          id="splashScreenContent"
          dangerouslySetInnerHTML={{ __html: DisclaimerMessage }}
        ></Typography>

        <div id="splashScreenFooter">
          <Button
            label="Accept"
            raised
            onClick={() => {
              setOpen(false);
              setState({
                showDisclaimer: false,
              });
              // Save to local storage
              setCache(Math.round(Date.now() / 1000));
            }}
          />
          <div>
            <Typography use="body2" id="version">
              Version: {Version}
            </Typography>
          </div>
        </div>
      </Overlay>
    </>
  );
};

export default SplashScreen;
